import axios from "axios";

import {WC_ENDPOINT, ADD_TO_CART_ACTION,GET_LOCALE_ACTION} from "@/constants";

export async function addToCart(productId: string|number, quantity: number, designId: string) {
	return await axios.post(`${WC_ENDPOINT}?action=${ADD_TO_CART_ACTION}&quantity=${quantity}&productId=${productId}&designId=${designId}`, {});
}

export async function getLocale() {
	return await axios.get(`${WC_ENDPOINT}?action=${GET_LOCALE_ACTION}`);
}
